import { RuleResult } from '../../../types/DeclarationP5'
import { LocationOfGoods } from '../common/types'

const NC0035Validator = {
  validateEconomicOperatorRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (locationOfGoods?.typeOfLocation === 'B' || locationOfGoods?.typeOfLocation === 'C') {
      return 'REQUIRED'
    }

    return 'NOT_ALLOWED'
  },

}

export default NC0035Validator
